// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../i/landings/lp-preloader-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#lp-preloader {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgb(243, 222, 193);
    z-index: 1000;
    top: 0px;
    left: 0px;
    display: block;
}

.lp-preloader-img {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    width: 860px;
    height: 495px;
    top: -webkit-calc(50vh - 247.5px);
    top: calc(50vh - 247.5px);
    left: -webkit-calc(50vw - 425px);
    left: calc(50vw - 425px);
}

.lp-preloader-bar {
    background: -webkit-gradient(linear, left top, right top, from(rgb(255, 145, 0)), to(rgb(255, 242, 88)));
    background: linear-gradient(to right, rgb(255, 145, 0) 0%, rgb(255, 242, 88) 100%);
}

.lp-preloader-pg-container {
    width: 70%;
    height: 80px;
    position: absolute;
    bottom: 5px;
    margin-left: 15%;
}

.lp-preloader-pg-label {
    font-family: FontinSansCR-Bold;
    font-size: 20px;
    margin-top: 20px;
    color: rgb(255, 247, 191);
    text-align: center;
}

.lp-preloader-pg-clipped {
    position: relative;
    border-radius: 5px;
    -webkit-clip-path: polygon(1.5% 0%, 98.5% 0%, 100% 44%, 100% 44%, 98.5% 100%, 1.5% 100%, 0px 44%, 0px 44%);
            clip-path: polygon(1.5% 0%, 98.5% 0%, 100% 44%, 100% 44%, 98.5% 100%, 1.5% 100%, 0px 44%, 0px 44%);
    background-color: rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./sources/s/components/lp-preloader/lp-preloader.pcss"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,aAAa;IACb,QAAQ;IACR,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yDAAgE;IAChE,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,iCAAyB;IAAzB,yBAAyB;IACzB,gCAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,wGAAkF;IAAlF,kFAAkF;AACtF;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0GAAkG;YAAlG,kGAAkG;IAClG,oCAAoC;AACxC","sourcesContent":["#lp-preloader {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    background-color: rgb(243, 222, 193);\n    z-index: 1000;\n    top: 0px;\n    left: 0px;\n    display: block;\n}\n\n.lp-preloader-img {\n    position: relative;\n    background-image: url(\"../../../i/landings/lp-preloader-bg.jpg\");\n    background-size: cover;\n    width: 860px;\n    height: 495px;\n    top: calc(50vh - 247.5px);\n    left: calc(50vw - 425px);\n}\n\n.lp-preloader-bar {\n    background: linear-gradient(to right, rgb(255, 145, 0) 0%, rgb(255, 242, 88) 100%);\n}\n\n.lp-preloader-pg-container {\n    width: 70%;\n    height: 80px;\n    position: absolute;\n    bottom: 5px;\n    margin-left: 15%;\n}\n\n.lp-preloader-pg-label {\n    font-family: FontinSansCR-Bold;\n    font-size: 20px;\n    margin-top: 20px;\n    color: rgb(255, 247, 191);\n    text-align: center;\n}\n\n.lp-preloader-pg-clipped {\n    position: relative;\n    border-radius: 5px;\n    clip-path: polygon(1.5% 0%, 98.5% 0%, 100% 44%, 100% 44%, 98.5% 100%, 1.5% 100%, 0px 44%, 0px 44%);\n    background-color: rgba(0, 0, 0, 0.5);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
